import {
  PublicClientApplication,
  BrowserCacheLocation,
  type IPublicClientApplication,
} from '@azure/msal-browser';
import { environment } from '../environments/environment';

let msalInstance: IPublicClientApplication | null = null;

export function getMsalInstance(): IPublicClientApplication {
  if (msalInstance) {
    return msalInstance;
  }

  const windowAny = globalThis as Record<string, unknown>;
  if (windowAny['__msalInstance']) {
    msalInstance = windowAny['__msalInstance'] as IPublicClientApplication;
    return msalInstance;
  }

  msalInstance = new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: `${globalThis.location.origin}/`,
      postLogoutRedirectUri: `${globalThis.location.origin}/`,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      allowRedirectInIframe: false,
      loggerOptions: {
        loggerCallback: (_level, message, containsPii) => {
          if (containsPii) return;
          if (message.includes('already an instance of MSAL.js')) return;
        },
        piiLoggingEnabled: false,
      },
    },
  });

  windowAny['__msalInstance'] = msalInstance;
  return msalInstance;
}

export const msalScopes = {
  loginScopes: [
    ...environment.msalConfig.auth.scopes,
    ...environment.apiConfig.articleplan_api.scopes,
  ],
  graphScopes: environment.apiConfig.graph_api.scopes,
  articleplanScopes: environment.apiConfig.articleplan_api.scopes,
};
